import { decode } from 'blurhash';
import { BLUR_HASH_DEFAULT } from '@/app/constants';

/** 全局的隐藏canvas，主要用于图片处理 */
export const CANVAS_HIDDEN_ID = `canvas_default_${Date.now()}`;

/** 获取全局唯一的隐藏canvas */
const getHiddenCanvas = (): HTMLCanvasElement | null => {
  if (typeof document === 'undefined') return null;
  const ele = document.getElementById(CANVAS_HIDDEN_ID);
  if (ele instanceof HTMLCanvasElement) return ele;

  // 创建隐藏canvas
  const canvas = document.createElement('canvas');
  canvas.id = CANVAS_HIDDEN_ID;
  canvas.hidden = true;
  canvas.style.position = 'fixed';

  // 将该节点添加进body，便于下次索引
  document.body.appendChild(canvas);
  return canvas;
};

/**
 * @function getDataUrlFromArr
 * @param {Uint8ClampedArray} arr
 * @param {int} w
 * @param {int} h
 * @param {number} opacity
 * @returns {string}
 */
const getDataUrlFromArr = (arr: Uint8ClampedArray, w: number, h: number, opacity = 1) => {
  const canvas = getHiddenCanvas();
  if (!canvas) return '';
  const ctx = canvas.getContext('2d');

  if (!ctx) return '';

  canvas.width = w;
  canvas.height = h;

  const imgData = ctx.createImageData(w, h);

  const data = new Uint8ClampedArray(arr);
  for (let i = 3; i < data.length; i += 4) {
    data[i] = data[i] * opacity;
  }

  imgData.data.set(data);
  ctx.putImageData(imgData, 0, 0);

  return canvas.toDataURL();
};

/**
 * 获取生成的高斯模糊背景图
 * @param blurHash 模糊哈希值
 * @param opacity 透明度，范围0-1
 * @returns 图片的 DataURL
 */
export const getBlurBackgroundImg = (blurHash?: string, opacity = 1) => {
  return getDataUrlFromArr(
    decode(blurHash ? blurHash : BLUR_HASH_DEFAULT.COLOR, BLUR_HASH_DEFAULT.SIZE, BLUR_HASH_DEFAULT.SIZE),
    BLUR_HASH_DEFAULT.SIZE,
    BLUR_HASH_DEFAULT.SIZE,
    opacity,
  );
};
